const SIZE_FALLBACK = [
  ["½″", "15"], ["¾″", "20"], ["1″", "25"], ["1¼″", "32"], ["1½″", "40"], ["2″", "50"]
];

const CODE_PREFIX = {
  Pipes: "PIPE",
  Adapters: "ADP",
  Bends: "BND",
  Tees: "TEE",
  Couplers: "CPL",
  Unions: "UNN",
  Bushings: "BSH",
  "End Caps": "ECP",
  Nipples: "NPL",
  Flanges: "FLG",
  Valves: "VLV",
  Clamps: "CLP",
  Solvent: "SOL"
};

const materialReplace = (text, material) => {
  if (!material || material === "uPVC") return text;
  if (material === "CPVC") {
    if (/uPVC\s+to\s+CPVC/i.test(text)) return text;
    return text.replace(/uPVC/g, "CPVC");
  }
  return text;
};

export const buildHelpers = (d) => {
  const ALL_PRODUCTS = d.PRODUCT_CATEGORIES.flatMap((c) =>
    c.products.map((p) => ({ ...p, categoryId: c.id, categoryName: c.name }))
  );

  const getProductBySlug = (slug) => ALL_PRODUCTS.find((p) => p.slug === slug);

  const getInstallationSteps = (product) =>
    product.installation || d.INSTALLATION_DEFAULTS[product.categoryId] || [];

  const getSkuCatalogue = (material = "uPVC") => {
    if (material === "CPVC") return d.CPVC_SKU_CATALOGUE;
    if (material === "SWR") return d.SWR_SKU_CATALOGUE;
    if (material === "UDS") return d.UDS_SKU_CATALOGUE;
    if (material === "AGRI") return d.AGRI_SKU_CATALOGUE;
    if (material === "BORE") return d.BORE_SKU_CATALOGUE;
    return d.UPVC_SKU_CATALOGUE.map((sku) => ({
      ...sku,
      name: materialReplace(sku.name, material),
      desc: materialReplace(sku.desc, material)
    }));
  };

  const getSkuTypes = (material = "uPVC") => {
    if (material === "CPVC") return d.CPVC_SKU_TYPES;
    if (material === "SWR") return d.SWR_SKU_TYPES;
    if (material === "UDS") return d.UDS_SKU_TYPES;
    if (material === "AGRI") return d.AGRI_SKU_TYPES;
    if (material === "BORE") return d.BORE_SKU_TYPES;
    return d.UPVC_SKU_TYPES;
  };

  const getSkuLongDesc = (type, material = "uPVC") => {
    if (material === "CPVC") return d.CPVC_SKU_LONG_DESC[type] || "";
    if (material === "SWR") return d.SWR_SKU_LONG_DESC[type] || "";
    if (material === "UDS") return d.UDS_SKU_LONG_DESC[type] || "";
    if (material === "AGRI") return d.AGRI_SKU_LONG_DESC[type] || "";
    if (material === "BORE") return d.BORE_SKU_LONG_DESC[type] || "";
    return materialReplace(d.SKU_LONG_DESC[type] || "", material);
  };

  const getSkuSizes = (sku) => {
    if (Array.isArray(sku.sizes)) return sku.sizes;
    const sizes = d.SKU_SIZE_TABLE[sku.type] || SIZE_FALLBACK;
    const prefix = CODE_PREFIX[sku.type] || "ITM";
    const nameSlug = sku.name
      .replace(/[^A-Za-z0-9]+/g, "")
      .toUpperCase()
      .slice(0, 4);
    return sizes.map(([inch, mm], i) => ({
      inch,
      mm,
      code: `BAI-${prefix}-${nameSlug}-${String(i + 1).padStart(2, "0")}`
    }));
  };

  return { ALL_PRODUCTS, getProductBySlug, getInstallationSteps, getSkuCatalogue, getSkuTypes, getSkuLongDesc, getSkuSizes };
};
